import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  Row,
  Col,
  Drawer,
  Typography,
  Steps,
  Tag,
  Image,
} from "antd";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import InitialInspectionForm from "./InitialInspectionForm";
import InitialInspectionSummary from "./InitialInspectionSummary";
import "../../summary.css";
import "./InitialInspectionHeader.css";
import { DoctorInitialContext } from "../../InspectionForms/HistoryForm/DoctorHistoryFormProvider";
import { getDoctorInspectionAPI } from "../../../../services/doctor.services";
import { LeftOutlined } from "@ant-design/icons";
import EditIcon from "../../../ui/EditIcon";
import CareItems from "../CareItems/CareItems";
import InvestigationsInitial from "../../Investigations/InvestigationsInitial";
import MedicinesInitial from "../MedicinesInitial.js/MedicinesInitial";
import ClosePopup from "./ClosePopup";
import NoDataPage from "../../../NoDataPages/NoDataPage";
import bedImg from "../../../../assets/images/patientIcons/bed.svg";
import assessmentIcon from "../../../../assets/images/nurseIcons/assessment.svg";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";
import { UserContext } from "../../../../context/UserContext";
import dayjs from "dayjs";
import useQuery from "../../../../hooks/useQuery";
import AiContextProvider from "./AiRecording/AiContextProvider";
import useIsMobile from "../../../../hooks/useIsMobile";

const items = [
  {
    title: "Initial Assessment",
  },
  {
    title: "Care Items",
  },
  {
    title: "Initial Medicine",
  },
  {
    title: "Initial Investigation",
  },
];
const InitialInspection = ({ refreshPage, editId, patientData }) => {
  const childref = useRef();
  const query = useQuery();
  const isMobile = useIsMobile();
  const { userDetails } = useContext(UserContext);
  const [visible, setVisible] = useState(false);
  const { formData, setFormData } = useContext(DoctorInitialContext);
  const [initialRefresh, setInitialRefresh] = useState(false);
  const [current, setCurrent] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const isActive = query?.status === "current";

  const setInitialAssessmentRefresh = () => {
    setInitialRefresh((prev) => !prev);
  };

  const openEdit = async () => {
    if (editId) {
      try {
        const response = await getDoctorInspectionAPI(editId);
        setFormData(response.data.data);
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    }
  };

  useEffect(() => {
    openEdit();
  }, [editId, initialRefresh]);

  // const onChange = (value) => {
  //   setCurrent(value);
  // };
  // console.log(patientData);

  const handleParentTabChange = (key) => {
    if (childref.current && childref.current.handleTabChange) {
      childref.current.handleTabChange(key);
    }
  };
  const editRole = getCookie(Role) || userDetails?.currRole;

  return (
    <>
      {editRole === "Doctor" ? (
        <>
                  {editId ? (
          <Row
            gutter={[12, 8]}
            className="ia-summary-meta-row"
            style={{ marginTop: 0, alignItems: "center" }}
          >
            <Col span={24}>
              <div className="ia-summary-meta-bar">
                {(formData?.submitted_by_first_name ||
                  formData?.submitted_by_last_name) && (
                  <Tag className="ia-summary-meta-tag ia-summary-meta-tag--submitted">
                    Submitted by: {formData?.submitted_by_first_name || ""}{" "}
                    {formData?.submitted_by_last_name || ""}
                  </Tag>
                )}
                <div className="ia-summary-meta-bottom">
                  {formData?.updated_at && (
                    <Tag className="ia-summary-meta-tag ia-summary-meta-tag--updated">
                      Updated at:{" "}
                      {dayjs(formData?.updated_at).format(
                        "DD/MM/YYYY hh:mm A"
                      )}
                    </Tag>
                  )}
                  {isActive && (
                    <div className="ia-summary-meta-actions">
                      <Button
                        type="primary"
                        onClick={() => {
                          setVisible(true);
                          setAddModal(false);
                          setCurrent(0);
                          setActiveTab("1");
                        }}
                        className={`${btnStyles.lgBtn} inv-btn`}
                        style={{ fontWeight: 500 }}
                      >
                        <EditIcon />
                        Edit
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </Col>

            <Col span={24}>
              <InitialInspectionSummary editId={editId} />
            </Col>
          </Row>
          ) : (
            <Row
              className="ia-empty-state"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: isMobile ? "auto" : "80vh",
                padding: isMobile ? "24px 0 32px" : undefined,
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>
                <NoDataPage
                  title={"Initial Assessment Not Yet Submitted "}
                  subtitle={isActive && "Kindly, upload an initial assessment here"}
                  image={assessmentIcon}
                />
                {isActive && (
                  <Button
                    type="primary"
                    onClick={() => {
                      setVisible(true);
                      setAddModal(true);
                    }}
                    style={{ fontWeight: 500 }}
                    className={`${btnStyles.lgBtn} btn-scale`}
                  >
                    Initial Assessment Form
                  </Button>
                )}
              </Col>
            </Row>
          )}
          {visible && (
            <Drawer
              styles={{
                body: {
                  overflow: "hidden",
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingInline: 24,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                },
              }}
              open={visible}
              width="100%"
              title={
                <div className="ia-drawer-header">
                  <div className="ia-drawer-header__main">
                    <LeftOutlined
                      className="ia-drawer-header__back"
                      onClick={() => setConfirmModal(true)}
                    />
                    <div className="ia-drawer-header__identity">
                      <div className="ia-drawer-header__name-row">
                        <Typography.Text
                          className="ia-drawer-header__name"
                          ellipsis={{
                            tooltip: `${patientData?.admission?.patient?.first_name || ""} ${patientData?.admission?.patient?.last_name || ""}`,
                          }}
                        >
                          {`${patientData?.admission?.patient?.first_name || ""} ${patientData?.admission?.patient?.last_name || ""}`}
                        </Typography.Text>
                        {patientData?.admission?.bed?.bed_no && (
                          <Tag
                            color="orange"
                            className="ia-drawer-header__bed"
                          >
                            <Image src={bedImg} preview={false} width={12} />{" "}
                            {patientData?.admission?.bed?.bed_no}
                          </Tag>
                        )}
                      </div>
                      <div className="ia-drawer-header__meta">
                        <Tag className="ia-drawer-header__tag">
                          {patientData?.admission?.patient?.age_by_dob}{" "}
                          {patientData?.admission?.patient?.gender}
                        </Tag>
                        <Tag className="ia-drawer-header__tag">
                          IP ID: {patientData?.admission?.ip_id}
                        </Tag>
                        {formData?.submitted_by_first_name && (
                          <Tag className="ia-drawer-header__tag">
                            Done by: {formData?.submitted_by_first_name}{" "}
                            {formData?.submitted_by_last_name || ""}
                          </Tag>
                        )}
                        <Tag className="ia-drawer-header__tag">
                          {dayjs(formData?.updated_at || new Date()).format(
                            "DD/MM/YYYY"
                          )}
                        </Tag>
                      </div>
                    </div>
                  </div>

                  {/* Desktop XXL: done-by column kept via meta row above for all breakpoints */}
                  {!formData?.care_items_generated || addModal ? (
                    <div className="ia-drawer-header__steps">
                      <Steps
                        current={current}
                        items={items}
                        responsive={false}
                      />
                    </div>
                  ) : null}
                </div>
              }
              footer={null}
              onClose={() => {
                setVisible(false);
                setActiveTab("1");
              }}
              closeIcon={null}
              keyboard={false}
            >
              {!formData?.care_items_generated || addModal ? (
                <>
                  {current === 0 && (
                    <AiContextProvider>
                      <InitialInspectionForm
                        visible={visible}
                        setVisible={setVisible}
                        refreshPage={refreshPage}
                        initialRefresh={setInitialAssessmentRefresh}
                        editId={editId}
                        setCurrent={setCurrent}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                      />
                    </AiContextProvider>
                  )}
                  {current === 1 && (
                    <CareItems
                      setCurrent={setCurrent}
                      initialRefresh={setInitialAssessmentRefresh}
                    />
                  )}
                  {current === 2 && (
                    <MedicinesInitial
                      setCurrent={setCurrent}
                      patientData={patientData}
                    />
                  )}
                  {current === 3 && (
                    <InvestigationsInitial
                      setCurrent={setCurrent}
                      setVisible={setVisible}
                      initialRefresh={setInitialAssessmentRefresh}
                    />
                  )}
                </>
              ) : (
                <InitialInspectionForm
                  visible={visible}
                  setVisible={setVisible}
                  refreshPage={refreshPage}
                  initialRefresh={setInitialAssessmentRefresh}
                  editId={editId}
                  setCurrent={setCurrent}
                  patientData={patientData}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
              )}

              {confirmModal && (
                <ClosePopup
                  open={confirmModal}
                  setOpen={setConfirmModal}
                  setVisible={setVisible}
                  setActiveTab={setActiveTab}
                  initialRefresh={setInitialAssessmentRefresh}
                />
              )}
            </Drawer>
          )}
        </>
      ) : (
        <Col span={24} style={{ textAlign: "center" }}>
          {editId ? (
            <InitialInspectionSummary editId={editId} />
          ) : (
            <NoDataPage
              title={"Doctor Initial Assessment Not Yet Submitted "}
              image={assessmentIcon}
            />
          )}
        </Col>
      )}
    </>
  );
};

export default InitialInspection;
